export default {
  left: {
    group: '我的分組:',
    location: '日程地點:',
    description: '日程說明:',
    scoreChart: '評分表:',
    scoreChartDescription: '評分表說明:',
  },
  logout: '登出',
  right: {
    title: '任務清單',
    incomplete: '未完成{number}人',
    complete: '已完成{number}人',
    signature: '評分簽字',
    searchPlaceholder: '名稱',
    mobileTitle: '任務:未完成{incomplete}人   已完成{complete}人',
  },
  table: {
    operation: '操作',
    status: '狀態',
    name: '名稱',
    number: '人數',
    incomplete: '未完成',
    time: '面試時間',
    people: '{number}人',
    preparation: '準備入場',
    tips: '已提示',
    revert: '撤銷',
    view: '查看',
    signature: '評分簽字',
    signed: '已簽字',
    viewDetail: '查看詳情',
    preview: '結果預覽',
  },
  nodata: '暫無任務',
  toEntriesMsg: '面試已結束打分',
  401: '登入過期,請重新登入',
  status: {
    waiting: '未開始',
    interviewing: '進行中',
    complete: '已結束',
    default: '出錯了',
  },
  signOut: {
    msg: '確定退出面試評分系統？',
    cancel: '取消退出',
  },
};
